import { SupportChatSeller } from './types'

const ALLOWED_STATUSES = new Set(['OPERATIONAL', 'ASSISTED_OPERATIONAL'])

export const isSupportChatEnabledForSeller = (
  sellerStatus?: SupportChatSeller['status']
) => ALLOWED_STATUSES.has(String(sellerStatus ?? ''))
